/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { QuestionSubSection } from './questionSubSection';
import { SectionTypeEnum } from './sectionTypeEnum';

/**
 * if type question, sub_sections is filled. if type text, value is filled
 */
export interface Section { 
    title: string;
    sectionType: SectionTypeEnum;
    subSections?: Array<QuestionSubSection>;
    value?: string;
    textInfo?: string;
    placeholder?: string;
    maxTextLen?: number;
}